(function () {
  if (window.SMFFilamentSwatchesLoaded) return;
  window.SMFFilamentSwatchesLoaded = true;

  function cardRoot(el) {
    return el.closest('.card-wrapper') || el.closest('.smf-col-card') || el.closest('li') || el.closest('.grid__item');
  }

  function selectSwatch(swatch) {
    const card = cardRoot(swatch);
    if (!card) return;
    card.querySelectorAll('.filament-swatch').forEach((s) => {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');
    const addButton = card.querySelector('.filament-quick-add');
    if (addButton) {
      addButton.textContent = addButton.dataset.addLabel + ' · ' + swatch.dataset.colorName;
      addButton.dataset.variantId = swatch.dataset.variantId;
    }
    const image = card.querySelector('.card__media img, .smf-col-card-image img');
    if (image && swatch.dataset.image) {
      image.srcset = swatch.dataset.image;
      image.src = swatch.dataset.image;
    }
  }

  // Volume tiers mirror the live automatic discounts: $2/$4/$7 off each.
  const QTY_TIERS = [
    { min: 50, offCents: 700 },
    { min: 25, offCents: 400 },
    { min: 10, offCents: 200 },
  ];
  const FREE_SHIP_CENTS = 3000;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function tierOff(qty) {
    for (const tier of QTY_TIERS) {
      if (qty >= tier.min) return tier.offCents;
    }
    return 0;
  }

  function getQty(card) {
    const value = card.querySelector('.filament-qty-value');
    return value ? Math.max(1, parseInt(value.textContent, 10) || 1) : 1;
  }

  function setQty(card, qty) {
    const value = card.querySelector('.filament-qty-value');
    if (value) value.textContent = String(Math.min(999, Math.max(1, qty)));
    updateNudge(card);
  }

  function updateNudge(card) {
    const nudge = card.querySelector('.filament-nudge');
    const buyRow = card.querySelector('.filament-buy-row');
    if (!nudge || !buyRow) return;
    const unit = Number(buyRow.dataset.unitPrice) || 0;
    if (!unit) return;
    // data-tiers="off" = product excluded from the volume discounts
    // (preset designs like Dapper Dan); talk free shipping only.
    const tiersOff = buyRow.dataset.tiers === 'off';
    const qty = getQty(card);
    const off = tiersOff ? 0 : tierOff(qty);
    const tierUnit = unit - off;
    const subtotal = qty * tierUnit;
    const lines = [];
    if (qty > 1) {
      let line = qty + ' × ' + money(tierUnit) + ' = ' + money(subtotal);
      if (off > 0) line += ' · <b>save ' + money(off * qty) + '</b>';
      lines.push(line);
    }
    if (subtotal < FREE_SHIP_CENTS) {
      const more = Math.ceil((FREE_SHIP_CENTS - subtotal) / tierUnit);
      lines.push('Add ' + more + ' more for <b>FREE shipping</b>');
    } else if (tiersOff) {
      lines.push('Ships <b>FREE</b>');
    } else {
      const next = QTY_TIERS.slice().reverse().find((tier) => qty < tier.min);
      if (next) {
        lines.push('Add ' + (next.min - qty) + ' more for <b>' + money(unit - next.offCents) + '/ea</b>');
      } else {
        lines.push('Best price: <b>' + money(tierUnit) + '/ea</b>');
      }
    }
    nudge.innerHTML = lines.join('<br>');
  }

  function addToCart(addButton) {
    const card = cardRoot(addButton);
    const source = card && (card.querySelector('.filament-swatches') || card.querySelector('.filament-buy-row'));
    const productUrl = (source && source.dataset.productUrl) || '/cart';
    if (!addButton.dataset.variantId) {
      window.location.href = productUrl;
      return;
    }
    addButton.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const body = { id: Number(addButton.dataset.variantId), quantity: getQty(card) };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then((state) => {
        addButton.disabled = false;
        setQty(card, 1);
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(() => {
        addButton.disabled = false;
        window.location.href = productUrl;
      });
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.filament-swatch');
    if (swatch) {
      if (!swatch.disabled) selectSwatch(swatch);
      return;
    }
    const qtyButton = event.target.closest('.filament-qty-btn');
    if (qtyButton) {
      const card = cardRoot(qtyButton);
      if (card) setQty(card, getQty(card) + Number(qtyButton.dataset.step));
      return;
    }
    const addButton = event.target.closest('.filament-quick-add');
    if (addButton) addToCart(addButton);
  });

  function initCards() {
    document.querySelectorAll('.filament-quick-buy').forEach((box) => {
      if (box.dataset.swatchInit) return;
      box.dataset.swatchInit = 'true';
      const swatches = box.querySelector('.filament-swatches');
      if (swatches) {
        // Dark Blue is the default card color when carried: it reads better than charcoal.
        const preferred = swatches.querySelector('.filament-swatch[data-color-name="Dark Blue"]:not([disabled])');
        const first = preferred || swatches.querySelector('.filament-swatch:not([disabled])');
        if (first) selectSwatch(first);
      }
      const card = cardRoot(box);
      if (card) updateNudge(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }
})();
